<button class="btn"
        type="{{buttonType}}"
        [ngClass]="buttonClasses"
        [disabled]="isDisabled"
        (click)="click($event)">

  <ng-content></ng-content>
</button>

